/* eslint-disable sort-keys */
import {sortSchedule} from 'modules/wineshops-list/helpers';
import {ISchedule} from 'modules/wineshops-list/models';

const DAYS_MAPPER = {
    monday: 'Пн',
    tuesday: 'Вт',
    wednesday: 'Ср',
    thursday: 'Чт',
    friday: 'Пт',
    saturday: 'Сб',
    sunday: 'Вс',
};

export interface IFormattedSchedule {
    [key: string]: {
        from: string;
        to: string | null;
    };
}

export class Schedule {
    constructor(schedule: ISchedule[]) {
        this.init(schedule);
    }

    private resultScheduleGroups: ISchedule[][] = [];
    private sortedSchedule: ISchedule[] = [];
    formattedSchedule: IFormattedSchedule[] = [];

    private init = (schedule: ISchedule[]) => {
        if (!schedule.length) {
            return;
        }

        this.sortedSchedule = sortSchedule(schedule);

        this.setResultScheduleGroups();
        this.setFormattedSchedule();
    };

    private getFormattedDayName = (day: string) => {
        return DAYS_MAPPER[day.toLowerCase() as keyof typeof DAYS_MAPPER];
    };

    private isScheduleFromAndToEqual = (a: ISchedule, b: ISchedule) => {
        const aFrom = a.from.trim();
        const aTo = a.to?.trim();

        const bFrom = b.from.trim();
        const bTo = b.to?.trim();

        return aFrom === bFrom && aTo === bTo;
    };

    private setResultScheduleGroups = () => {
        let currentScheduleGroup: ISchedule[] = [];

        this.sortedSchedule.forEach((current) => {
            if (!currentScheduleGroup.length) {
                currentScheduleGroup.push(current);

                return;
            }

            const currentGroupItem = currentScheduleGroup[0];
            const isScheduleEqual = this.isScheduleFromAndToEqual(current, currentGroupItem);

            if (isScheduleEqual) {
                currentScheduleGroup.push(current);

                return;
            }

            this.resultScheduleGroups.push(currentScheduleGroup);
            currentScheduleGroup = [current];
        });

        this.resultScheduleGroups.push(currentScheduleGroup);
    };

    private setFormattedSchedule = () => {
        this.formattedSchedule = this.resultScheduleGroups.map((scheduleGroup) => {
            const {day, from, to} = scheduleGroup[0];
            const firstDayFormatted = this.getFormattedDayName(day);

            if (1 === scheduleGroup.length) {
                return {
                    [firstDayFormatted]: {
                        from,
                        to,
                    },
                };
            }

            const lastGroupItem = scheduleGroup[scheduleGroup.length - 1];
            const lastDayFormatted = this.getFormattedDayName(lastGroupItem.day);

            return {
                [`${firstDayFormatted}-${lastDayFormatted}`]: {
                    from,
                    to,
                },
            };
        });
    };
}
